import React, { useState, useRef } from "react";
import { Calendar, Upload, CheckCircle, AlertCircle, Loader2, Camera, X } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HERO_IMAGE = "https://customer-assets-lxgj4vgw.emergentagent.net/job_732c40bf-63ea-451c-b997-eb6b46d3eef5/artifacts/0rfj0f0z_COM.png";

const PHOTO_SLOTS = [
  { key: "face_photo", label: "Face Picture", required: true },
  { key: "front_nude_photo", label: "Front Fully Naked", required: true },
  { key: "back_nude_photo", label: "Back Fully Naked", required: true },
  { key: "dick_photo", label: "Dick Picture", required: true },
  { key: "ass_photo", label: "Ass Picture", required: false },
];

const FETISH_PRESETS = [
  "Anal", "Body Hair", "Feet", "Kissing", "Latex", "Cum", "Nipples", "Piercing",
  "Role Play", "Spanking", "S & M", "Socks", "Tickling", "Wrestling", "Armpits",
  "Bears", "Fisting", "Foreskin", "Jocks", "Leather", "Muscle", "PNP", "Rimming",
  "Shaving", "Smoking", "Tattoos", "Verbal", "WS", "Oral", "Daddy", "Twinks",
  "Groups", "Bondage", "Toys", "Dirty"
];

export default function ModelApplyNew({ onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [uploading, setUploading] = useState({});
  const [previews, setPreviews] = useState({}); // local object-URL previews only
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    twitter_handle: "",
    submission_type: "studio_shooting",
    // Proposed dates (max 3)
    proposed_date_1: "",
    proposed_date_2: "",
    proposed_date_3: "",
    // Live Show fields  
    show_type: "",
    show_availability: "",
    // Social Media / Platforms
    link_in_bio: "",
    tiktok_handle: "",
    bluesky_handle: "",
    onlyfans_status: "have_existing",
    onlyfans_link: "",
    onlyfans_link_2: "", // Second OnlyFans
    faphouse_link: "",
    justforfans_status: "have_existing",
    justforfans_link: "",
    // Photos
    face_photo: "",
    front_nude_photo: "",
    back_nude_photo: "",
    dick_photo: "",
    ass_photo: "",
    // Physical (REQUIRED)
    body_type: "",
    dick_size: "",
    languages: "",
    // Collab details
    role_position: "",
    interests_kinks: "",
    boundaries: "",
    content_types: "",
    availability: "",
    location: "",
    fetishes: [], // Fetishes & Interests
    additional_notes: "",
    add_to_crm: false,
    website: "" // honeypot
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const toggleFetish = (fetish) => {
    setFormData(prev => ({
      ...prev,
      fetishes: prev.fetishes.includes(fetish)
        ? prev.fetishes.filter(f => f !== fetish)
        : [...prev.fetishes, fetish]
    }));
  };


  const handlePhoto = async (key, file) => {
    if (!file) return;
    if (!file.type || !file.type.startsWith("image/")) return toast.error("Please choose an image file");
    if (file.size > 15 * 1024 * 1024) return toast.error("Photo too large (max 15MB)");
    setUploading((u) => ({ ...u, [key]: true }));
    try {
      const fd = new FormData();
      fd.append("file", file, file.name || `${key}.jpg`);
      const res = await axios.post(`${API}/model-applications/upload-photo`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // Photos are stored privately: the server returns an upload token, never a URL.
      const token = res.data?.upload_token;
      if (!token) throw new Error("Upload failed");
      setFormData(prev => ({ ...prev, [`${key}_upload`]: token }));
      setPreviews((p) => {
        if (p[key]) URL.revokeObjectURL(p[key]);
        return { ...p, [key]: URL.createObjectURL(file) };
      });
      toast.success(`${key.replace(/_/g, " ")} uploaded`);
    } catch (e) {
      const msg = e?.response?.data?.detail || e?.message || "Upload failed";
      toast.error(`Upload failed: ${msg}`);
    } finally {
      setUploading((u) => ({ ...u, [key]: false }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Honeypot check
    if (formData.website) {
      toast.error("Invalid submission");
      return;
    }

    // Basic validation
    if (!formData.name || !formData.email || !formData.twitter_handle) {
      toast.error("Please fill in all required fields (Name, Email, X Handle)");
      return;
    }
    if (!formData.body_type || !formData.dick_size || !formData.languages) {
      toast.error("Please fill in all physical stats (Body Type, Dick Size, Languages)");
      return;
    }
    if (!formData.interests_kinks || !formData.boundaries) {
      toast.error("Please fill in Kinks/Interests and Boundaries");
      return;
    }
    // Check required photos
    for (const slot of PHOTO_SLOTS) {
      if (slot.required && !formData[`${slot.key}_upload`]) {
        toast.error(`${slot.label} is required`);
        return;
      }
    }

    setLoading(true);
    try {
      await api.post("/api/model-applications", formData);
      setSubmitted(true);
      toast.success("Application submitted successfully!");
      // Call onSuccess callback if provided (for unified portal)
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Failed to submit application. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-pink-900 flex items-center justify-center p-6">
        <div className="max-w-2xl w-full bg-black/40 backdrop-blur-xl rounded-2xl p-8 border border-white/10 text-center">
          <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-white mb-3">Application Submitted!</h1>
          <p className="text-gray-300 mb-6">
            Thank you for applying! Gio reviews every model application personally. You'll hear from him at <span className="text-pink-400">{formData.email}</span> if there's a fit for a collab.
          </p>
          <button
            onClick={() => window.location.href = "/"}
            className="px-6 py-3 rounded-lg bg-gradient-to-r from-pink-500 to-purple-600 text-white font-medium hover:from-pink-600 hover:to-purple-700 transition"
          >
            Return to Homepage
          </button>
        </div>
      </div>
    );
  }

  const showLiveShowFields = formData.submission_type === "live_show" || formData.submission_type === "both";

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-pink-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header with Hero Image */}
        <div className="text-center mb-8">
          <img 
            src={HERO_IMAGE} 
            alt="giopilos.com" 
            className="w-full max-w-4xl mx-auto h-auto rounded-2xl shadow-2xl mb-6"
            style={{ maxHeight: "250px", objectFit: "cover" }}
          />
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-3 bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">
            Model Application
          </h1>
          <p className="text-gray-300 text-lg">
            Join our exclusive roster of performers
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Live Show Fields */}
          {showLiveShowFields && (
            <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-pink-500/30 space-y-4">
              <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                <span className="text-2xl">🎭</span>
                Live Show Details
              </h2>
              
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Show Type</label>
                <input
                  type="text"
                  name="show_type"
                  value={formData.show_type}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="Cam show, Stage performance, Club appearance, etc."
                />
              </div>

              <div>
                <label className="block text-gray-300 mb-2 font-medium">Show Availability</label>
                <textarea
                  name="show_availability"
                  value={formData.show_availability}
                  onChange={handleChange}
                  rows={3}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition resize-none"
                  placeholder="Your available times for live shows..."
                />
              </div>
            </div>
          )}

          {/* Basic Info */}
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10 space-y-4">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 flex items-center justify-center text-sm font-bold">1</span>
              Basic Information
            </h2>
            
            <div>
              <label className="block text-gray-300 mb-2 font-medium">Name <span className="text-pink-400">*</span></label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition"
                placeholder="Your stage name"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 font-medium">Email <span className="text-pink-400">*</span></label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 font-medium">X (Twitter) Handle <span className="text-pink-400">*</span></label>
              <input
                type="text"
                name="twitter_handle"
                value={formData.twitter_handle}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition"
                placeholder="@yourusername"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 font-medium flex items-center gap-2">
                <Calendar className="w-4 h-4 text-purple-400" />
                Proposed Shoot Date
              </label>
              <input
                type="date"
                name="proposed_shoot_date"
                value={formData.proposed_shoot_date}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition"
              />
              <p className="text-sm text-gray-400 mt-2">Suggest your preferred date (we'll confirm availability)</p>
            </div>
          </div>

          {/* OnlyFans / JFF */}
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10 space-y-4">
            <h2 className="text-xl font-bold text-white mb-4">Platform Accounts</h2>
            
            <div>
              <label className="block text-gray-300 mb-2 font-medium">OnlyFans Status <span className="text-pink-400">*</span></label>
              <div className="flex gap-2 mb-2">
                <label className="flex items-center gap-2 text-gray-300 cursor-pointer">
                  <input
                    type="radio"
                    name="onlyfans_status"
                    value="have_existing"
                    checked={formData.onlyfans_status === "have_existing"}
                    onChange={handleChange}
                  />
                  <span>Have Existing</span>
                </label>
                <label className="flex items-center gap-2 text-gray-300 cursor-pointer">
                  <input
                    type="radio"
                    name="onlyfans_status"
                    value="need_to_create"
                    checked={formData.onlyfans_status === "need_to_create"}
                    onChange={handleChange}
                  />
                  <span>Need to Create</span>
                </label>
              </div>
              <input
                type="url"
                name="onlyfans_link"
                value={formData.onlyfans_link}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                placeholder="https://onlyfans.com/yourprofile"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 font-medium">JustForFans Status <span className="text-pink-400">*</span></label>
              <div className="flex gap-2 mb-2">
                <label className="flex items-center gap-2 text-gray-300 cursor-pointer">
                  <input
                    type="radio"
                    name="justforfans_status"
                    value="have_existing"
                    checked={formData.justforfans_status === "have_existing"}
                    onChange={handleChange}
                  />
                  <span>Have Existing</span>
                </label>
                <label className="flex items-center gap-2 text-gray-300 cursor-pointer">
                  <input
                    type="radio"
                    name="justforfans_status"
                    value="need_to_create"
                    checked={formData.justforfans_status === "need_to_create"}
                    onChange={handleChange}
                  />
                  <span>Need to Create</span>
                </label>
              </div>
              <input
                type="url"
                name="justforfans_link"
                value={formData.justforfans_link}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                placeholder="https://justforfans.com/yourprofile"
              />
            </div>

            {/* New Social Media Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-gray-700">
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Link in Bio</label>
                <input
                  type="url"
                  name="link_in_bio"
                  value={formData.link_in_bio}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="https://linktr.ee/yourname"
                />
              </div>
              
              <div>
                <label className="block text-gray-300 mb-2 font-medium">TikTok Handle</label>
                <input
                  type="text"
                  name="tiktok_handle"
                  value={formData.tiktok_handle}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="@yourtiktok"
                />
              </div>
              
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Bluesky Handle</label>
                <input
                  type="text"
                  name="bluesky_handle"
                  value={formData.bluesky_handle}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="@yourname.bsky.social"
                />
              </div>

              <div>
                <label className="block text-gray-300 mb-2 font-medium">OnlyFans #2</label>
                <input
                  type="url"
                  name="onlyfans_link_2"
                  value={formData.onlyfans_link_2}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="Second OF account (if any)"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-gray-300 mb-2 font-medium">Faphouse Profile</label>
                <input
                  type="url"
                  name="faphouse_link"
                  value={formData.faphouse_link}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="https://faphouse.com/yourprofile"
                />
              </div>
            </div>
          </div>

          {/* Required Photos */}
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Camera className="w-6 h-6 text-purple-400" />
              Required Photos <span className="text-pink-400">*</span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
              {PHOTO_SLOTS.map((slot) => (
                <PhotoSlot
                  key={slot.key}
                  slot={slot}
                  value={previews[slot.key]}
                  busy={!!uploading[slot.key]}
                  onChange={(f) => handlePhoto(slot.key, f)}
                />
              ))}
            </div>
          </div>

          {/* Physical Stats */}
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10 space-y-4">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 flex items-center justify-center text-sm font-bold">2</span>
              Physical Stats
            </h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Body Type <span className="text-pink-400">*</span></label>
                <select
                  name="body_type"
                  value={formData.body_type}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white focus:border-purple-500 focus:outline-none transition"
                >
                  <option value="">— Select —</option>
                  <option value="slim">Slim / Twink</option>
                  <option value="athletic">Athletic / Fit</option>
                  <option value="muscular">Muscular / Jock</option>
                  <option value="bodybuilder">Bodybuilder</option>
                  <option value="bear">Bear / Cub</option>
                  <option value="chubby">Chubby</option>
                  <option value="otter">Otter</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Dick Size <span className="text-pink-400">*</span></label>
                <input
                  type="text"
                  name="dick_size"
                  value={formData.dick_size}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="e.g., 18 cm"
                />
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Languages <span className="text-pink-400">*</span></label>
                <input
                  type="text"
                  name="languages"
                  value={formData.languages}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="English, Greek, Italian..."
                />
              </div>
            </div>
          </div>

          {/* Performance Details */}
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10 space-y-4">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 flex items-center justify-center text-sm font-bold">3</span>
              Performance Details
            </h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Role/Position</label>
                <input
                  type="text"
                  name="role_position"
                  value={formData.role_position}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="Top, Bottom, Versatile, Model"
                />
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Location</label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="City, Country"
                />
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Content Types</label>
                <input
                  type="text"
                  name="content_types"
                  value={formData.content_types}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="Solo, Duo, Group, Photos, Videos"
                />
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Availability</label>
                <input
                  type="text"
                  name="availability"
                  value={formData.availability}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition"
                  placeholder="Days/times you're available"
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-300 mb-2 font-medium">Kinks / Interests <span className="text-pink-400">*</span></label>
              <textarea
                name="interests_kinks"
                value={formData.interests_kinks}
                onChange={handleChange}
                required
                rows={3}
                className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition resize-none"
                placeholder="What types of content are you interested in creating?"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 font-medium">Boundaries / Limits <span className="text-pink-400">*</span></label>
              <textarea
                name="boundaries"
                value={formData.boundaries}
                onChange={handleChange}
                required
                rows={3}
                className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition resize-none"
                placeholder="What you're NOT comfortable with"
              />
            </div>
          </div>


          {/* Fetishes & Interests */}
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
            <h3 className="text-lg font-bold text-white mb-2">Fetishes & Interests</h3>
            <p className="text-sm text-gray-400 mb-4">
              Select the fetishes you're interested in ({formData.fetishes.length} selected)
            </p>
            <div className="flex flex-wrap gap-2">
              {FETISH_PRESETS.map((fetish) => (
                <button
                  key={fetish}
                  type="button"
                  onClick={() => toggleFetish(fetish)}
                  className={`px-3 py-1.5 rounded-full text-sm font-medium transition ${
                    formData.fetishes.includes(fetish)
                      ? "bg-purple-500 text-white"
                      : "bg-gray-800 text-gray-300 hover:bg-gray-700"
                  }`}
                >
                  {fetish}
                </button>
              ))}
            </div>
          </div>


          {/* Additional Notes */}
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
            <label className="block text-gray-300 mb-2 font-medium">Additional Notes</label>
            <textarea
              name="additional_notes"
              value={formData.additional_notes}
              onChange={handleChange}
              rows={4}
              className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none transition resize-none"
              placeholder="Anything else we should know..."
            />
          </div>

          {/* Honeypot */}
          <input
            type="text"
            name="website"
            value={formData.website}
            onChange={handleChange}
            className="hidden"
            tabIndex={-1}
            autoComplete="off"
          />

          {/* Proposed Dates */}
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10 space-y-4">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Calendar className="w-6 h-6 text-purple-400" />
              Proposed Shooting/Performance Dates (Max 3)
            </h2>
            
            <div className="space-y-3">
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Date Option 1</label>
                <input
                  type="date"
                  name="proposed_date_1"
                  value={formData.proposed_date_1}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white focus:border-purple-500 focus:outline-none transition"
                />
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Date Option 2 (Optional)</label>
                <input
                  type="date"
                  name="proposed_date_2"
                  value={formData.proposed_date_2}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white focus:border-purple-500 focus:outline-none transition"
                />
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Date Option 3 (Optional)</label>
                <input
                  type="date"
                  name="proposed_date_3"
                  value={formData.proposed_date_3}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-black/60 border border-white/10 text-white focus:border-purple-500 focus:outline-none transition"
                />
              </div>
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 rounded-xl bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-lg hover:from-pink-600 hover:to-purple-700 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-lg shadow-purple-500/50"
          >
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                Submitting...
              </>
            ) : (
              "Submit Application"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

function PhotoSlot({ slot, value, busy, onChange }) {
  const inputRef = useRef(null);
  
  return (
    <div className="relative">
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => onChange(e.target.files?.[0])}
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        className="w-full aspect-square rounded-xl border-2 border-dashed border-white/10 hover:border-purple-500/50 transition flex flex-col items-center justify-center gap-2 bg-black/30 relative overflow-hidden disabled:opacity-50"
      >
        {busy ? (
          <Loader2 className="w-8 h-8 text-purple-400 animate-spin" />
        ) : value ? (
          <>
            <img src={value} alt={slot.label} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/50 opacity-0 hover:opacity-100 transition flex items-center justify-center">
              <Upload className="w-8 h-8 text-white" />
            </div>
          </>
        ) : (
          <>
            <Camera className="w-8 h-8 text-gray-500" />
            <span className="text-xs text-gray-400 text-center px-2">{slot.label}</span>
            {slot.required && <span className="text-pink-400 text-xs">*</span>}
          </>
        )}
      </button>
    </div>
  );
}